export default function inline(state) {
  var tokens = state.tokens; // Parse inlines

  for (var i = 0, l = tokens.length; i < l; i++) {
    var tok = tokens[i];

    if (tok.type === 'inline') {
      state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
  }
}